import React from "react";
var __jsx = React.createElement;
import Head from 'next/head';

var SafeHead = function SafeHead(_ref) {
  var children = _ref.children;
  var filteredChildren = children.filter(function (elem) {
    return !!elem;
  });
  return __jsx(Head, null, filteredChildren);
};

export default SafeHead;